<h6 class="content-block">Security Characteristics</h6>
<div id="nutrients" class="parcoords"></div>
